import {Injectable} from '@angular/core';

import {BehaviorSubject} from 'rxjs';

@Injectable({providedIn: 'root'})
export class TokenRefreshService {
    private isRefreshing = false;
    private refreshSubject = new BehaviorSubject<string | null>(null);

    getRefreshObservable() {
        return this.refreshSubject.asObservable();
    }

    startRefresh() {
        this.isRefreshing = true;
        this.refreshSubject.next(null);
    }

    completeRefresh(token: string) {
        this.isRefreshing = false;
        this.refreshSubject.next(token);
        this.refreshSubject.complete();
        // Create a new subject for future refreshes
        this.refreshSubject = new BehaviorSubject<string | null>(null);
    }

    failRefresh(error: any) {
        this.isRefreshing = false;
        this.refreshSubject.error(error);
        // Create a new subject for future refreshes
        this.refreshSubject = new BehaviorSubject<string | null>(null);
    }

    get isRefreshingInProgress() {
        return this.isRefreshing;
    }
}
